





















import Vue, { PropType } from "vue";
import { Component } from "vue-property-decorator";
import { RecommendationExtra } from "../store/model";

const TypeCellProps = Vue.extend({
  props: {
    rowRecommendation: {
      type: Object as PropType<RecommendationExtra>,
      required: true
    }
  }
});

@Component
export default class TypeCell extends TypeCellProps {
  get recommenderSubtype(): string {
    return this.rowRecommendation.typeCol;
  }
  iconName(): string {
    switch (this.recommenderSubtype) {
      case "CHANGE_MACHINE_TYPE":
        return "mdi-move-resize-variant";
      case "STOP_VM":
        return "mdi-monitor-off";
      case "INCREASE_PERFORMANCE":
        return "mdi-monitor-screenshot";
      case "SNAPSHOT_AND_DELETE_DISK":
        return "mdi-harddisk-remove";
      default:
        return "mdi-cloud-question";
    }
  }
}
